import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Column, OrderImportService, OrderImportStatus, UserService } from '../../services';
import { flatten } from '../../utils/flatten';
import { IOrderImportFilter } from '../../interfaces/order-import-filter';
import { IOrderImport } from '../../interfaces/upload-order/order-import';
import { Table } from 'primeng';

import { MessageService } from 'primeng';
import { noop, Subject, Observable } from 'rxjs';
import moment from 'moment';

interface EventPage {
  page: number;
}

@Component({
  selector: 'order-completed',
  templateUrl: './order-completed.component.html',
  styleUrls: ['./order-completed.component.scss'],
  providers: [],
})
export class OrderCompletedComponent implements OnInit {
  cols: any;
  orderImports: IOrderImport[];
  isLoadingOrderDetails: boolean = false;
  public selectedOrderImport: IOrderImport;
  displayItems: number = 2;
  selectedOrderFilename = '';

  public orderImportFilterVal: IOrderImportFilter;
  public orderImportValidationResult: IOrderImport;
  @ViewChild('completedOrderDt') completedOrderDt: Table;

  noImports = false;

  _selectedImport: IOrderImport;

  get selectedImport() {
    return this._selectedImport;
  }

  set selectedImport(value: IOrderImport) {
    if (value) {
      this._selectedImport = value;
      this.getOrderDetails(value);
    }
  }

  constructor(
    private messageService: MessageService,
    private orderImportService: OrderImportService,
    private userService: UserService,
  ) {}
  ngOnInit() {
    this.initialiseDefaultFilters();
    this.load();
    this.initCols();
  }

  private async initCols(): Promise<void> {
    const hasCustomerBookingRole = await this.userService.isUserInRole('CUSTOMER_BOOKING');
    const hasCustomerPriceRole = await this.userService.isUserInRole('CUSTOMER_PRICE');

    let excludedFields: Set<string> = new Set();

    if (hasCustomerBookingRole) {
      excludedFields = new Set(['min_price', 'max_price', 'price']);
    } else if (hasCustomerPriceRole) {
      excludedFields = new Set(['min_price', 'price']);

      const maxPriceIndex = this.orderImportService.cols.findIndex(
        (col) => col.field === 'max_price',
      );
      if (maxPriceIndex !== -1) {
        this.orderImportService.cols[maxPriceIndex] = {
          ...this.orderImportService.cols[maxPriceIndex],
          header: 'Price',
        };
      }
    }

    this.cols = this.orderImportService.cols.filter((col) => !excludedFields.has(col.field));
  }

  initialiseDefaultFilters() {
    this.orderImportFilterVal = {
      first: 0,
      rows: null,
      sortField: null,
      sortOrder: 1,
      filters: {
        createdOnFrom: { value: null },
        createdOnTo: { value: null },
        status: { value: [OrderImportStatus.Transferred] },
        includeDetails: { value: null },
      },
    };
  }
  load() {
    this.orderImportService
      .getCompletedOrderImports(flatten(this.orderImportFilterVal))
      .then((res) => {
        this.orderImports = res && res.length > 0 ? res.reverse() : null;
        if (!this.orderImports) {
          this.noImports = true;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isLoadingOrderDetails = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Fetching Orders',
          detail: `An error occurred while fetching details of this Order`,
        });
      });
  }

  getOrderDetails(orderImport: IOrderImport, callback: () => void = noop) {
    if (orderImport && orderImport.id) {
      this.selectedOrderImport = orderImport;
      let fname = orderImport.fileName.substring(0, orderImport.fileName.lastIndexOf('.'));
      this.selectedOrderFilename =
        orderImport.customerName +
        ' (' +
        fname +
        ') ' +
        moment(orderImport.createdOn).format('ddd d MMM yyyy (hh-mm)');
      this.isLoadingOrderDetails = true;
      this.orderImportService
        .getOrderImportDetails(orderImport.id)
        .then((res) => {
          this.selectedOrderImport.orderImportDetails = res;
          this.isLoadingOrderDetails = false;
          callback();
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingOrderDetails = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Fetching Order Details',
            detail: `An error occurred while fetching details of this Order`,
          });
        });
    }
  }

  hideDialog() {
    this.isLoadingOrderDetails = false;
  }

  ngOnDestroy() {}

  viewOrder($event: any, orderImport: any) {
    $event.stopPropagation();
    this.getOrderDetails(orderImport);
  }

  downloadToCSV() {
    this.completedOrderDt.exportCSV();
  }

  onPage(page: EventPage) {
    if (page.page > 0) {
      const pageNumber = page.page * this.displayItems;
      this.selectedOrderImport = this.orderImports[pageNumber];
      this.getOrderDetails(this.selectedOrderImport);
    }
  }
}
